export function fetchGetProduct(pid) {
	return fetch(`${process.env.REACT_APP_BASE_API}order/apis/getProducts.php?pid=` + pid)
		.then(response => response.json())
		.catch((error) => {
			console.log(error);
		})
}

export function fetchAddonsDigitalSignature(pid) {
	return fetch(`${process.env.REACT_APP_BASE_API}order/apis/getAddonsVPS.php?pid=` + pid)
		.then(response => response.json())
		.catch((error) => {
			console.log(error);
		})
}